import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSetStateLocalTaxCode extends Layout {
    checkboxUpdateCurrentRecordOnly: Checkbox;
    excludabletextboxCheckDate: ExcludableTextbox;
    labelInfo: Label;
    labelTaxCodes: Label;
    panelTaxCodes: Panel;
    sourceDrsPayrollHist: DataSource;
    sourceSetStateLocalTaxCode: DataSource;
    textboxCity: Textbox;
    textboxCounty: Textbox;
    textboxPayee: Textbox;
    textboxSUI: Textbox;
    textboxState: Textbox;
}
